import { useEffect } from "react";

const DEFAULT_TITLE = "Enquiry Management Software for Tuition & Enrichment Centres Singapore | EnquiryOps";
const DEFAULT_DESCRIPTION =
  "Enquiry Management Software for Tuition & Enrichment Centres Singapore | EnquiryOps. Capture parent enquiries, book approved trials, and automate follow-up.";

// Sets a unique document title and meta description per page.
// Restores site defaults on unmount so navigation stays consistent.
export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const previous = meta.getAttribute("content");
    meta.setAttribute("content", description || DEFAULT_DESCRIPTION);

    return () => {
      document.title = DEFAULT_TITLE;
      meta.setAttribute("content", previous || DEFAULT_DESCRIPTION);
    };
  }, [title, description]);
}
